import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

const base = () => `${process.env.REACT_APP_API_URL || ''}/api/v3/task-saved-filters`;
const config = () => ({ headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } });

/**
 * Saved filters in the Tasks rail (rev6 Part 4). Each holds a view and its query string. PMs and
 * admins share one with the team, and make no-login links to those built on All tasks.
 */
const TaskSavedFilterService = {
    list: async () => (await axios.get(base(), config())).data,
    /** body: { name, viewKey, query, sharedWithTeam } */
    create: async (body) => (await axios.post(base(), body, config())).data,
    /** body: any of { name, query, sharedWithTeam, revision } */
    update: async (id, body) => (await axios.put(`${base()}/${id}`, body, config())).data,
    remove: async (id) => axios.delete(`${base()}/${id}`, config()),

    links: async (id) => (await axios.get(`${base()}/${id}/links`, config())).data,
    createLink: async (id, expiresAt) => (await axios.post(`${base()}/${id}/links`, { expiresAt }, config())).data,
    turnOffLink: async (id, linkId) => axios.delete(`${base()}/${id}/links/${linkId}`, config()),
};

/** The address people open without logging in. */
export const viewLink = (token) => `${window.location.origin}/v/${token}`;

export default TaskSavedFilterService;
